// DCL-366: screenshot-style previews of how the queued logo and header color
// will look in the web header, notification emails, and referral PDFs.
angular.module('modals')
    .controller('BrandingPreviewModalController', ['$scope', '$uibModalInstance', 'preview',
        function ($scope, $uibModalInstance, preview) {
            $scope.logo = preview.logoDataUrl;
            $scope.today = new Date();

            // The color comes from a free-text input; fall back to white for
            // anything that isn't a valid 3- or 6-digit hex so the navbar mock
            // and the contrast pick below always agree.
            var raw = (preview.backgroundColor || '').trim();
            $scope.backgroundColor = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.test(raw)
                ? (raw.charAt(0) === '#' ? raw : '#' + raw)
                : '#ffffff';

            // Pick a readable nav text color for the chosen background (WCAG
            // relative luminance), the way the hand-tuned branding stylesheets
            // do — light text on dark headers and vice versa.
            $scope.navTextColor = (function () {
                var hex = $scope.backgroundColor.slice(1);
                if (hex.length === 3) {
                    hex = hex.replace(/(.)/g, '$1$1');
                }
                var channel = function (offset) {
                    var c = parseInt(hex.substr(offset, 2), 16) / 255;
                    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
                };
                var luminance = 0.2126 * channel(0) + 0.7152 * channel(2) + 0.0722 * channel(4);
                return luminance > 0.179 ? '#333333' : '#ffffff';
            })();

            $scope.close = function () {
                $uibModalInstance.dismiss('close');
            };
        }]);
